(function($, window, undefined) {
    $(document).ready(function() {
        $('form.ticketFormSubmit').submit(function(e) {
          	$('.generalFormError').hide();

            var serializedArray = $(this).serializeArray();
            var serializedObject = {};
            var body = '';

            for (counter in serializedArray) {
                if ($('form.ticketFormSubmit [name="' + serializedArray[counter].name + '"]')[0].localName === 'select') {
                    serializedObject[serializedArray[counter].name] = $($('form.ticketFormSubmit [name="' + serializedArray[counter].name + '"] :selected')[0]).text();
                    serializedObject[serializedArray[counter].name + 'OptGroupValue'] = $($('form.ticketFormSubmit [name="' + serializedArray[counter].name + '"] :selected')[0]).closest('optgroup').attr('value') || '';
                } else {
                    serializedObject[serializedArray[counter].name] = serializedArray[counter].value;
                }
            }

            for (attrName in serializedObject) {
                body += attrName + ': ' + serializedObject[attrName] + '\n'
            }

            $.ajax({
                url: 'https://gateway.ecommerce-wh.com/support/tickets',
                type: 'POST',
                cache: false,
                crossDomain: true,
                data: JSON.stringify({
                    ticket: {
                      	recipient: window.liquidVars.contactEmail, //set this variable into html with shop.email liquid var (this can't be defined here)
                        requester: {
                            name: serializedObject.Name,
                            email: serializedObject.Email
                        },
                        subject: (serializedObject.QuestionOptGroupValue ? serializedObject.QuestionOptGroupValue + ' | ' : '') + serializedObject.Question,
                        comment: {
                            body: body
                        },
                        custom_fields: [{ id: "44966709", value: domainTag }]
                    }
                }),
                contentType: 'application/json',
              	success: function() {
              		window.location.href = window.location.origin + window.location.pathname + '?contact_posted=true'
                },
                error: function() {
                	$('.generalFormError').show();
                }
            });

            e.preventDefault();
        });
    });
})(jQuery, window);